import { render, staticRenderFns } from "./VFolderEntryEdit.vue?vue&type=template&id=53ee515d&"
import script from "./VFolderEntryEdit.vue?vue&type=script&lang=ts&"
export * from "./VFolderEntryEdit.vue?vue&type=script&lang=ts&"
import style0 from "./VFolderEntryEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports